import PardotImport from 'components/Imports/PardotImport'

export default PardotImport
